import { makeStyles, tokens } from '@fluentui/react-components';

export const useAutopayDiscountTagStyles = makeStyles({
    autopayDiscountTag: {
        marginTop: tokens.spacingVerticalM,
        marginBottom: tokens.spacingVerticalM
    }
});
